export const parseBToCMessage = (message) => {
    return {
        id: message.id,
        createdAt: message.created_at,
        fromAddress: message.from_address,
        toDomain: message.to_domain || message.to_domain__domain,
        messageType: message.message_type,
        messageText: message.message_text,
        sended: message.sended,
        message_reference: message.message_reference,
        referenced_message: message.referenced_message,
        message_count: message.message_count,
        logoUrl: message.logoUrl,
    };
};
//# sourceMappingURL=b_to_c.utils.js.map